import { ChevronDown } from "lucide-react";

export const currentDashboardYear = new Date().getFullYear();

export const dashboardYears = () => {
  const current = currentDashboardYear;
  return Array.from({ length: 5 }, (_, index) => current - index);
};

export default function YearSelect({ year, onChange, className }) {
  return (
    <div className="relative">
      <select
        value={year}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label="Year"
        className={`px-4 py-2 pr-8 text-gray-700 bg-white rounded-lg border appearance-none cursor-pointer focus:outline-none focus:ring-2 ${className}`}
      >
        {dashboardYears().map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <ChevronDown
        className="absolute right-3 top-1/2 text-gray-400 transform -translate-y-1/2 pointer-events-none"
        size={16}
      />
    </div>
  );
}
